import { render, staticRenderFns } from "./registrationInfo.vue?vue&type=template&id=1986ac8e&scoped=true&"
import script from "./registrationInfo.vue?vue&type=script&lang=js&"
export * from "./registrationInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1986ac8e",
  null
  
)

export default component.exports